export const EMPTY_ITEM_CONTENT: string = '--';
